<template>
    <el-tooltip
        effect="dark" 
        content="Help"
        placement="bottom"
        :open-delay="300"
        :disabled="helpPop">
        <el-popover class="question"
            trigger="click"
            width="240"
            placement="right-start"
            popper-class="login-popover"
            :visible-arrow="false"
            v-model="helpPop">
            <div slot="reference" style="cursor: pointer;">
                <CancelIcon slot="reference" v-show="helpPop"></CancelIcon>
                <QuestionIcon v-show="!helpPop"></QuestionIcon>
            </div>
            <slot></slot>
        </el-popover>
    </el-tooltip>
</template>

<script>
import Icons from '../icons'

export default {
    name: 'help-tooltip',

    data() {
        return {
            helpPop: false
        }
    },

    props: ['content'],

    components: {
        ...Icons
    }
}
</script>

<style lang="scss">
.el-popover.login-popover {
	font-size: 12px;
	word-break: break-word;
	text-align: left;
	line-height: 16px;
}
</style>